import API from "@/common/API";
import { FormatMoney } from "@/common/helpers";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const Summary = (props) => {
    const { t } = useTranslation("global");
    const [record, setRecord] = useState(null);
    const bindData = async () => {
        try {
            const request = await API.getAction(`placeDashboard/summary?id=${props.model.id}`);
            if (request.status === 200) {
                setRecord(request.data.response);
            }
        } catch (e) {
            console.error(e);
        }
    }
    useEffect(() => {
        bindData();
    }, []);
    return <div className="mb-4">
        <Row>
            {record?.ochoaInfo && <>
                <Col xs={12}>
                    <h2 className="display-4 mt-4">{t("Ochoa")}</h2>
                    <hr />
                </Col>
                <Col xs={6} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>RD$ {FormatMoney(record?.totalInvoiced || 0)}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Total Invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>RD$ {FormatMoney(record?.totalQuoted || 0)}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Total Quotations")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.amountOfQuotes || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Amount of Quotes")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.amountOfInvoices || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Amount of Invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.totalQuotedNotInvoiced || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Quotes without invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
            </>}

            <Col xs={12}>
                <h2 className="display-4 mt-4">{t("Shearly BI")}</h2>
                <hr />
            </Col>
            <Col xs={6} md={4} className="mb-2">
                <Card className="shadow-sm">
                    <Card.Body className="py-2">
                        <h3>{record?.totalVisits || 0}</h3>
                    </Card.Body>
                    <Card.Footer className="py-2">
                        {t("Total Visits")}
                    </Card.Footer>
                </Card>
            </Col>
            <Col xs={6} md={4} className="mb-2">
                <Card className="shadow-sm">
                    <Card.Body className="py-2">
                        <h3>{record?.totalDispatchVisits || 0}</h3>
                    </Card.Body>
                    <Card.Footer className="py-2">
                        {t("Total Dispatched Visits")}
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    </div>;
};

export default Summary;